import React, { useMemo, useState } from 'react'
import CompanyLogo from './CompanyLogo'
import Tag from './ui/Tag'
import WatchlistButton from './ui/WatchlistButton'
import CompanyDescription from './comapnyDescription'
import { useProject } from '../context/project'
import { useGeneral } from '../context/general'
import { Skeleton } from '@mui/material'
import { Alarm, InfoOutlined } from '@mui/icons-material'
import WebsiteTag from './ui/websiteTag/WebsiteTag'
import styles from './CompanyInfo.module.scss'
import axios from 'axios'

export default function CompanyData({tickerInfo, ticker, projectId, setOpenAlertsBoard}){
    const [modal, setModal] = useState(false)
    const openAlertsBoard = () => setOpenAlertsBoard(true)
    const { privateCompany } = useProject()
    const openModal = () => setModal(true)
    const { projectMethods, checkIfProjectExist, setWatchlistData, WatchlistData } = useGeneral()
    // const { action } = projectMethods.getWatchlistStatus(projectId)
    const action = WatchlistData.filter(x=>x.value==ticker)
    
    
    
    
    const project = useMemo(() => checkIfProjectExist(ticker) ,[ticker, checkIfProjectExist])

    const HandleWatchlistAdd = async () =>{
        if(action.length>0) {
            // const resJson = await fetch('/api/removefromWatchlist', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({'ticker':ticker})
            // })
            const resJson = await axios({
                method: 'POST',
                url: '/api/removefromWatchlist',
                data:{'ticker':ticker}
            })
            const res = await resJson.data
            Array.isArray(res) && setWatchlistData(res)
        }
        else{
            // const resJson = await fetch('/api/insertWatchlistData', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({'data':[{'name':project.company_name,'value':ticker}]})
            // })
            const resJson = await axios({
                method: 'POST',
                url: '/api/insertWatchlistData',
                data:{'data':[{'name':project.company_name,'value':ticker}]}
            })
            const res = await resJson.data
            Array.isArray(res) && setWatchlistData(res)
        }
    }

    return(tickerInfo && 
        <div className={styles['company-data']}>
            <div>
                {/* <CompanyLogo image={tickerInfo.image} website={tickerInfo.website } ticker={ticker} size={38}/> */}
                <h1>{tickerInfo.companyName}</h1>
                <Tag label={privateCompany ? 'PRIVATE' : ticker} />
                {project?.uuid ? 
                    <WatchlistButton active={action.length>0} handleClick={HandleWatchlistAdd} externalClassName={styles['company_data-btn']} value={project}/>
                    : <Skeleton variant="rect" width={30} height={30} />}
                {/* <button className={styles['company_data-btn']} onClick={openAlertsBoard}><Alarm/></button> */}
            </div>
            <div className={styles['link']}>
                <WebsiteTag website={tickerInfo.website} companyName={tickerInfo.companyName}/>
                <Tag label={(<div className={styles['info']} onClick={openModal}><InfoOutlined/><b>Company's description</b></div>)}/>
            </div>
            <CompanyDescription tickerInfo={tickerInfo} modal={modal} setModal={setModal} ticker={ticker}/>
        </div>
    )
}